export default "__VITE_ASSET__COwVw8n1__"